import { Injectable, Inject } from "@angular/core";
import { TRANSLATIONS } from "./translation"; // import our opaque token
import { TranslationSubstitutions, ImpulseError, ImpulseErrorHTTPResponse, isImpulseError, isImpulseErrorHTTPResponse } from "./models";

@Injectable()
export class TranslateService {
	private _currentLang = "";

	// inject our translations
	constructor(@Inject(TRANSLATIONS) private _translations: any) {
	}

	public get currentLang() {
		return this._currentLang;
	}

	public use(lang: string): void {
		// set current language
		this._currentLang = lang;
	}

	public translate(error: ImpulseErrorHTTPResponse | ImpulseError): string;
	public translate(key: string, substitutions?: TranslationSubstitutions): string;
	public translate(key: ImpulseErrorHTTPResponse | ImpulseError | string, substitutions?: TranslationSubstitutions): string {
		// if they gave us a full HTTP response object that we need to pull json from, do that first
		if (isImpulseErrorHTTPResponse(key)) {
			const error = key.error;
			key = error.message;
			substitutions = error.substitutions;
		} else if (isImpulseError(key)) {
			substitutions = key.substitutions;
			key = key.message;
		}

		let result = this.getStringFromKey(key);

		// X language just gets the normal translation but prepends a value
		if (this.currentLang === "xx") {
			result = `XX-${result}`;
		}

		// finally, apply any substitutions
		if (substitutions) {
			for (const substitutionKey of Object.keys(substitutions)) {
				result = result.replace(`[[${substitutionKey}]]`, substitutions[substitutionKey]);
			}
		}

		return result;
	}

	public instant(key: string) {
		// call translation
		return this.translate(key);
	}

	private getStringFromKey(key: string) {
		/*
		first, try the proper nouns
		second, try the translations for this language
		third, try the translations for english
		finally, just return the unaltered string if not present in any translation file
		*/
		if (this._translations["proper"] && this._translations["proper"][key]) {
			return this._translations["proper"][key];
		} else if (this._translations[this.currentLang] && this._translations[this.currentLang][key]) {
			return this._translations[this.currentLang][key];
		} else if (this._translations["en"] && this._translations["en"][key]) {
			return this._translations["en"][key];
		} else {
			return key;
		}
	}
}
